import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { api as campaignsApi } from '#adapter/api/campaigns';
import { ICode200 as ICampaignInfo } from '#adapter/api/campaigns/v5/campaign-info/get';
import { ICode200 as IBudgetInfo } from '#adapter/api/main/budget/get';

export const initialCampaignState: Partial<ICampaignInfo> = {
    create_date  : undefined,
    id           : undefined,
    campaign_name: undefined,
    status_id    : undefined,
    type         : undefined
};

export const initialBudgetState: Partial<IBudgetInfo> = {
    cash   : undefined,
    netting: undefined,
    total  : undefined
};

export const initialActiveGroupsState: Record<string, boolean | undefined> = {
    isAllInactiveGroups: undefined
};

export const editCampaignSlice = createSlice({
    initialState: initialCampaignState,
    name        : 'campaign-edit-slice',
    reducers    : {
        reset: () => initialCampaignState,
        set  : (state, action: PayloadAction<Partial<ICampaignInfo & { status?: number }>>) => {
            return {
                ...state,
                ...action.payload,
                status_id: action.payload.status_id
            };
        }
    },
    extraReducers: (builder) => {
        builder
            .addMatcher(
                campaignsApi.endpoints.v5CampaignInfoGet.matchFulfilled,
                editCampaignSlice.caseReducers.set
            )
            .addMatcher(
                campaignsApi.endpoints.v5CampaignInfoGet.matchRejected,
                editCampaignSlice.caseReducers.reset
            );
    }
});

export const budgetCampaignSlice = createSlice({
    initialState: initialBudgetState,
    name        : 'budget-campaign-slice',
    reducers    : {
        reset: () => initialBudgetState,
        set  : (state, action: PayloadAction<Partial<IBudgetInfo>>) => {
            return {
                ...state,
                ...action.payload
            };
        }
    }
});

export const activeGroupsSlice = createSlice({
    initialState: initialActiveGroupsState,
    name        : 'active-groups-slice',
    reducers    : {
        reset: () => initialActiveGroupsState,
        set  : (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                isAllInactiveGroups: action.payload
            };
        }
    }
});
